// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"336":"92b229f8","363":"eb60f07c","428":"dd2d3236","581":"989ed4dd","717":"53428b06"}[chunkId] + ".chunk.css";
};